import React from "react";

const MainLoading = () => {
  return (
    <div className=" w-full h-screen bg-white overflow-hidden">
      <div className="bg-[#efefef] animate-pulse py-4 px-6 flex items-center justify-between z-10 fixed w-full top-0">
        <div className=" flex items-center gap-20">
          <div className="w-40 h-8 rounded-lg animate-pulse bg-[#97979750]"></div>
          <div className="w-40 h-8 rounded-lg animate-pulse bg-[#97979750]"></div>
        </div>
        <div className=" flex items-center gap-4">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#97979750]"></div>
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#97979750]"></div>
          <div className=" flex flex-col gap-3 items-start justify-center">
            <div className="w-40 h-3 rounded-lg animate-pulse bg-[#97979750]"></div>
            <div className="w-28 h-3 rounded-lg animate-pulse bg-[#97979750]"></div>
          </div>
        </div>
      </div>
      <div className=" w-[280px] h-screen bg-[#efefef] animate-pulse px-3 py-4 flex flex-col gap-2 fixed top-0 left-0 mt-[72px]">
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
        <div className=" flex items-center justify-start gap-4 p-3 rounded-lg bg-[#97979750] animate-pulse">
          <div className="w-10 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
          <div className="w-40 h-10 rounded-lg animate-pulse bg-[#efefef]"></div>
        </div>
      </div>
      <div className=" h-[calc(100vh-112px)] w-[calc(100%-320px)] bg-[#efefef] ml-[300px] mt-[92px] rounded-xl p-6 ">
        <div className=" flex justify-between items-center">
          <div className=" w-40 h-10 bg-[#97979750] animate-pulse rounded-lg"></div>
          <div className=" w-40 h-10 bg-[#97979750] animate-pulse rounded-lg"></div>
        </div>
        <div className=" flex justify-center flex-col items-start gap-4 pt-4">
          <div className=" w-full h-40 bg-[#97979750] animate-pulse rounded-lg "></div>
          <div className=" w-full h-40 bg-[#97979750] animate-pulse rounded-lg "></div>
        </div>
        <div className=" flex justify-end gap-5 pt-4 items-center">
          <div className=" w-40 h-10 bg-[#97979750] animate-pulse rounded-lg"></div>
          <div className=" w-40 h-10 bg-[#97979750] animate-pulse rounded-lg"></div>
        </div>
      </div>
    </div>
  );
};

export default MainLoading;
